module.exports = __webpack_public_path__ + "static/img/2.38b9de1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/2.png
// module id = aYML
// module chunks = 0